import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {APP_BASE_HREF} from '@angular/common';
import {AppComponent} from './app.component';
import { AgmCoreModule } from "../agm/core";
import {AngularFireModule} from "@angular/fire";
import {AngularFireDatabaseModule} from "@angular/fire/database";
import {environment} from "./environment";
import {LoginComponent} from "./login/login.component";
import {AppRoutes, AppRoutingModule} from "./app.routing.module";
import {RouterModule} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import { AngularFireAuthModule} from "@angular/fire/auth";
import {HttpClientModule} from "@angular/common/http";
import {TrackerComponent} from "./tracker/tracker.component";
import {AngularFirestoreModule} from "@angular/fire/firestore";


@NgModule({
  imports:      [
    BrowserModule,
    FormsModule,
      AngularFireModule.initializeApp(environment.firebase),
      AngularFireDatabaseModule,
      AngularFirestoreModule,
      HttpClientModule,
      AppRoutingModule,
      RouterModule.forRoot(AppRoutes),
      AngularFireAuthModule,


      AgmCoreModule.forRoot({
      // please get your own API key here:
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
      apiKey: 'AIzaSyCUJ1n1KTJHDaDdVmpY686z8AAle8GAbQQ',
          libraries: ['places', 'drawing', 'geometry'],
    })
  ],
    providers: [{provide: APP_BASE_HREF, useValue : '/' }],
  declarations: [ AppComponent,
    TrackerComponent,
    LoginComponent,HomeComponent],
  bootstrap:    [ AppComponent,

  ]})
export class AppModule { }
